module.exports = __webpack_public_path__ + "img/equityIcon1.dfafa4f1.png";